/**
 * Create by zhuzhaoqing
 * Description: login
 * Date: 2023/3/31 10:12
 **/
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import request from './request'

const serveName = process.env.VUE_APP_SERVENAME

// 单点登录
export const ssoLoginFetch = () => request(`/${serveName}/getActiveUser`, null, 'GET', null)

// 退出登录
export const ssoLogoutFetch = () => request(`/${serveName}/logout`, null, 'GET', null)

// 登录前提交前端地址
export const setFrontUrlFetch = (param: { frontUrl: string; frontErrUrl: string; frontLogoutUrl: string }) =>
  request(`/${serveName}/setFrontUrl`, param, 'GET_LOGIN')
